import React, { FC, useMemo, useState } from 'react';

import {
	EvComboboxOption,
	EvLabelDefault,
	EvSelectNew,
	EvTextInput
} from '@evinced-private/ui-common';

import { SCOPE_ACTIONS } from '../../../../types/scope/ScopeActions';
import { getUrlRuleError } from '../../EditViewButtonHelper';
import { IScopeRuleRowProps } from '../scope-rules-list/ScopeRulesList.types';

import { ScopeRuleRow } from './ScopeRuleRow';
import {
	ACTION_SELECT_ARIA_LABEL,
	ACTION_SELECT_PLACEHOLDER,
	ARIA_LABEL,
	REMOVE_URL_BUTTON_TITLE,
	TEXT_INPUT_PLACEHOLDER,
	URL_ACTIONS,
	VALUE_INPUT_LABEL
} from './UrlRuleRow.constants';

export const UrlRuleRow: FC<IScopeRuleRowProps> = ({ rule, onRemove, onRuleChange }) => {
	const [url, setUrl] = useState<string>(rule?.url ?? '');
	const [selectedOption, setSelectedOption] = useState<EvComboboxOption>(
		URL_ACTIONS.find((option) => rule?.scopeAction === option.value)
	);

	const urlError = useMemo(() => getUrlRuleError(url), [url]);

	return (
		<ScopeRuleRow
			removeButtonTitle={REMOVE_URL_BUTTON_TITLE}
			onRemove={onRemove}
			actionControl={
				<EvSelectNew
					id="url-rule-select"
					options={URL_ACTIONS}
					selectedValue={[selectedOption]}
					onSelectChange={(selectedItem: EvComboboxOption[]) => {
						setSelectedOption(selectedItem[0]);
						onRuleChange?.({
							...rule,
							scopeAction: selectedItem[0].value as SCOPE_ACTIONS
						});
					}}
					placeholder={ACTION_SELECT_PLACEHOLDER}
					ariaLabel={ACTION_SELECT_ARIA_LABEL}
					label={ARIA_LABEL}
				/>
			}
			valueControl={
				<>
					<EvLabelDefault>{VALUE_INPUT_LABEL}</EvLabelDefault>
					<EvTextInput
						ariaLabel={VALUE_INPUT_LABEL}
						value={url}
						placeholder={TEXT_INPUT_PLACEHOLDER}
						error={urlError}
						onChange={(val: string) => {
							setUrl(val);
							onRuleChange?.({ ...rule, url: val });
						}}
					/>
				</>
			}
		/>
	);
};
